import React, { Component } from "react";
import Header from "../components/Header/index";
import Footer from "../components/Footer/index";
import OtpComponent from "../components/NewForgotPass/index";
import { Redirect } from "react-router-dom";

class Forgot extends Component<{history:any},{}> {
  componentDidMount(){
    // document.title = "Forgot Password - Tortilla";
    document.title = "Forgot Password - Kyochon"
  }
  render() {
    // if (!localStorage.mainToken) {
    //   return <Redirect to="/landing" />
    // }
    return (
      <div className="page-wrapper">
        <div id="page-wrap">
          <Header history={this.props.history}/>
          <OtpComponent />
          <Footer />
        </div>
        
      </div>
    );
  }
}

export default Forgot;
